<template>
    <section class="content">
    <h4>{{ title }}</h4>
    <div v-html="content"></div>
    <div class="footer">
        <span v-if="prev" style=""><a :href="prev">Prev</a></span>
        <router-link to="/">Contents</router-link>
        <span v-if="next" style=""><a :href="next">Next</a></span>
    </div>
    </section>
</template>

<script>
export default {
  name: 'Page',
  props: {
    title: String,
    content: String,
    prev: String,
    next: String,
  },
};


/* eslint-disable-next-line no-unused-vars */
function play(filename) {
  const audio = document.querySelector('#audio');
  const loading = document.querySelector('#loading');
  audio.pause();
  audio.src = `/static/mp3s/${filename}.mp3`;
  loading.style.display = 'inline';
  loading.innerHTML = 'loading...';
  audio.play().then(() => { loading.style.display = 'none'; })
    .catch(() => { loading.innerHTML = 'Sorry, unable to load that recording.'; });
}
window.play = play;
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.signature {
  margin-top: 0px;
  transform: translateY(-20px);
}

#player {
  position: fixed;
  bottom: 0;
  background-color: white;
  border-top: 1px solid #777;
  text-align: center;
  max-width: 750px;
  width: 100%;
  z-index: 100;
}

</style>



// WEBPACK FOOTER //
// src/components/Page.vue